module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ../node_modules/react-hot-loader/index.js
// module id = 396
// module chunks = 0